const getters = {
  getTasks: state => state.tasks
}

const actions = {
  setTasks ({ commit }, data) {
    commit('setTasks', data)
  }
}

const mutations = {
  setTasks (state, data) {
    state.tasks = data
  }
}

const state = {
  tasks: []
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
